/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import get from 'lodash/get';

export const selectCMSwitchWidgetData = (state) => state?.cmSwitchWidgetData;

const isIrisFallBackEnabled = false;
export const selectIRISFallBack = createSelector(selectCMSwitchWidgetData, (cmSwitchWidgetData) =>
    get(cmSwitchWidgetData, 'isIrisFallBackEnabled', isIrisFallBackEnabled)
);
